import { redirect, useNavigate, useParams } from "react-router-dom";


import classes from './PrintPage.module.css'
import { useEffect, useState } from "react";
import { generatePDFForPrint } from "../lib/fetchApi";
import { authorizationHeaders, developmentProxyUrl, hasBasicAuth } from "../lib/basicAuth";
import PrintComponentV2 from "../components/print_page_v2/PrintComponentV2";



export default function PrintPageServerDetails() {
    const params = useParams()
    const navigate = useNavigate();
    const [caseData, setCaseData] = useState(null)


    async function getCaseData(id, header_slug) {
        let data = await generatePDFForPrint(null, id, header_slug)
        if (data && data.errorMessage) {
            navigate(`/`);
        } else {
            setCaseData(data)
        }
    }

    async function addScript() {
        const src = developmentProxyUrl(`${process.env.REACT_APP_PDF_URL}/pdf-assets/pdf-settings.js`)
        const script = document.createElement('script')
        if (hasBasicAuth()) {
            const response = await fetch(src, { headers: authorizationHeaders() })
            if (!response.ok) {
                return
            }
            script.text = await response.text()
        } else {
            script.src = src
            script.async = true
        }
        document.head.appendChild(script)
    }

    useEffect(() => {
        if (params && params.caseId && params.varSlug) {
            // generatePDFForPrint
            addScript()
            getCaseData(params.caseId, params.varSlug)
        } else {
            redirect('/')
        }

    }, [params])
    
    return (
        <div className={classes.print_container}>
            {caseData && <PrintComponentV2 activeCase={caseData}/>}             
        </div>
    );
}